"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getVehicleJob = void 0;
/**
 * Get a vehicle job by job reference
 */
var getVehicleJob = function (instance) {
    return function (reg, ref, config) {
        return instance.get("/vehicles/registration/".concat(reg, "/jobs/").concat(ref), config);
    };
};
exports.getVehicleJob = getVehicleJob;
